import axios from 'axios'

interface Metadata {
  [key: string]: string
}

interface Headers {
  [key: string]: string
}

export default function uploadToS3(file: File, metadata: Metadata, url: string, type: string) {
  const headers: Headers = {
    'Content-Type': type
  }
  Object.keys(metadata).forEach(key => {
    headers[`x-amx-meta-${key}`] = metadata[key]
  })

  return axios.put(url, file, { headers })
}
